import React, { useCallback, useEffect, useRef, useState } from "react";

import { Drawer } from "@app/scripts/react-general-components/Drawer";
import { ResponsiveImage } from "@app/scripts/react-general-components/ResponsiveImage";
import { AccountCreateForm } from "@app/scripts/react-account-drawer/components/AccountCreateForm";
import { AccountLoginForm } from "@app/scripts/react-account-drawer/components/AccountLoginForm";
import { AccountRecoverForm } from "@app/scripts/react-account-drawer/components/AccountRecoverForm";
import { useMobile } from "@app/scripts/react-hooks/mobile";

import type { AuthStates, Image } from "@app/scripts/types";

export type AccountDrawerProps = {
  content: any;
  image: Image;
  mobileImage: Image;
  createImage: Image;
  mobileCreateImage: Image;
};

export const AccountDrawer: React.FC<AccountDrawerProps> = (props) => {
  const { content, image, mobileImage, createImage, mobileCreateImage } = props;

  const [formState, setFormState] = useState<AuthStates>("login");

  const isMobile = useMobile();

  const bannerImage = (
    <div className="login-drawer__banner-image">
      <ResponsiveImage image={image} mobileImage={mobileImage} />
    </div>
  );
  const createBannerImage = (
    <div className="login-drawer__banner-image login-drawer__banner-image--register">
      <ResponsiveImage image={createImage} mobileImage={mobileCreateImage} />
    </div>
  );

  const title =
    formState === "login"
      ? content?.login_page?.title
      : formState === "recover"
      ? content?.recover_password?.title
      : formState === "create"
      ? content?.register?.title
      : "";

  const ref = useRef(null);

  const triggerSubmit = useCallback(
    (e) => {
      e.preventDefault();
      ref?.current?.click?.();

      (document.querySelector(".header__icon--menu") as HTMLElement)?.click();
    },
    [ref?.current]
  );

  useEffect(() => {
    if (ref?.current) {
      document.querySelectorAll("[data-openaccountdrawer]")?.forEach((btn) => {
        btn.addEventListener("click", triggerSubmit);
      });
    }

    return () => {
      document.querySelectorAll("[data-openaccountdrawer]")?.forEach((btn) => {
        btn.removeEventListener("click", triggerSubmit);
      });
    };
  }, [ref?.current]);

  const handleToggle = (toggleOpen) => {
    setFormState("login");
    toggleOpen?.();
  };

  return (
    <Drawer
      heading={title}
      drawerClassName="ui-drawer__cart"
      opensFrom={isMobile ? "bottom" : "right"}
      customButton={({ toggleOpen }) => (
        <a ref={ref} title="ACCOUNT" className="header__menu-item header__menu-item list-menu__item link link--text" onClick={() => handleToggle(toggleOpen)}>
          <span>ACCOUNT</span>
        </a>
      )}
    >
      <div className={"customer login page-width " + formState}>
        {formState === "login" ? (
          <AccountLoginForm switchForm={setFormState} content={content} bannerImage={bannerImage} />
        ) : formState === "recover" ? (
          <AccountRecoverForm switchForm={setFormState} content={content} />
        ) : formState === "create" ? (
          <AccountCreateForm switchForm={setFormState} content={content} bannerImage={createBannerImage} />
        ) : null}
      </div>
    </Drawer>
  );
};
